<template>
	<div class='online-details'>
		<div class='content'>
			<h1>{{getText('ErrorHeader')}}</h1>
			<p>{{getText('ErrorHint')}}</p>

			<ErrorMessage :message="error_message" v-if='error_message !== undefined && error_message.length > 0' />

		</div>
	</div>
</template>

<style scoped lang="scss">
	.online-details{
		position: relative;

		.content{
			width: 100%;

			p{
				padding: 20px 0px;
			}
		}
	}
</style>

<script>

import ErrorMessage from "@/components/messages/ErrorMessage";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "Error",
	components: {
		ErrorMessage
	},
	props: {
		error: {
			type: String
		}
	},
	data(){
		return {
			error_message: ""
		};
	},
	beforeMount(){
		this.error_message = this.error;
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		}
	}
}
</script>
